<template>
  <div
    v-if="competenceAreas && competenceAreas.length > 0"
    class="counselor-competence-list"
  >
    <ul class="counselor-competence-list__list">
      <li
        v-for="(selectedCompetenceArea, index) in selectedCompetenceAreas"
        :key="selectedCompetenceArea.name + index"
        class="counselor-competence-list__list-item filtered"
      >
        {{ selectedCompetenceArea.name }}
      </li>
      <li
        v-for="(competenceArea, index) in limitedCompetenceAreas"
        :key="competenceArea.name + index"
        class="counselor-competence-list__list-item"
      >
        {{ competenceArea.name }}
      </li>
      <li
        v-if="competenceAreas.length > maxItems && !showAll"
        class="counselor-competence-list__list-item counselor-competence-list__list-item--show-all"
      >
        <button @click="showAll = !showAll" v-text="`+ ${showAllText}`" />
      </li>
    </ul>
  </div>
</template>

<script>
import { HIDDEN_UNTIL_FILTERED_COMPETENCES } from 'Constants/counselorGridFilters';

export default {
  name: 'CompetenceAreaPills',

  props: {
    competenceAreas: {
      type: Array,
      required: true,
    },
    filteredCompetences: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      showAllText: theme_vars.counselorSlider.showAll,
      maxItems: 3,
      showAll: false,
    };
  },

  computed: {
    selectedCompetenceAreas() {
      return this.competenceAreas.filter((area) =>
        this.compareStringWithValuesNameInArray(area, this.filteredCompetences)
      );
    },

    limitedCompetenceAreas() {
      const maxItemsLeft = this.maxItems - this.selectedCompetenceAreas.length;
      const competencesToShow = this.competenceAreas
        .filter(
          (area) =>
            !this.compareStringWithValuesNameInArray(
              area,
              this.filteredCompetences
            )
        )
        .filter(
          (area) =>
            !this.compareStringWithValuesNameInArray(
              area,
              HIDDEN_UNTIL_FILTERED_COMPETENCES
            )
        );

      if (maxItemsLeft <= 0) {
        return this.showAll ? competencesToShow : [];
      }

      return this.showAll
        ? competencesToShow
        : competencesToShow.slice(0, maxItemsLeft);
    },
  },

  methods: {
    compareStringWithValuesNameInArray(value, array) {
      if (!Array.isArray(array) || array.length === 0) {
        return false;
      }

      return array.some(
        (item) =>
          item.toLowerCase() === value.name.toLowerCase() ||
          item.toLowerCase() === value.slug.toLowerCase()
      );
    },
  },
};
</script>
